import type { Visit } from "@/common/types/types";
import { VisitRow } from "./visit-row";

interface VisitListProps {
  visits: Visit[];
  refresh: () => void;
}

export function VisitList({ visits, refresh }: VisitListProps): JSX.Element {
  return (
    <>
      <div className="divide-y">
        {visits.map((visit) => (
          <VisitRow key={visit.id} refresh={refresh} visit={visit} />
        ))}
      </div>
    </>
  );
}
